export const env = (key: string) => {
  let value = process.env['REACT_APP_' + process.env.REACT_APP_ENV.toUpperCase() + '_' + key]

  if (!value) value = process.env['REACT_APP_' + key]

  return value ? value : ''
}
